import { useI18n } from 'vue-i18n'

export function useMapAltText(imgObject: {
  alt_de: string
  alt_fr: string
  alt_en: string
}) {
  const { localeProperties } = useI18n()

  switch (localeProperties.value.language) {
    case 'de':
      return imgObject.alt_de
    case 'fr':
      return imgObject.alt_fr
    case 'en':
      return imgObject.alt_en
    default:
      return imgObject.alt_de
  }
}
